
























































































































































































import LazyComponent from "v-lazy-component/vue2";
import { SfLoader } from "@storefront-ui/vue";
import {
  computed,
  defineComponent,
  onMounted,
  useRoute,
  ref,
} from "@nuxtjs/composition-api";
import productGetters from "~/modules/catalog/product/getters/productGetters";
import { useWishlist } from "~/modules/wishlist/composables/useWishlist";
import { useUiHelpers, useImage, useProduct } from "~/composables";
import { useVoucherStore } from "~/stores/extensionApi";
import VoucherItem from "~/components/vouchers/VoucherItem.vue";
import { Voucher } from "~/composables/useVoucher/useVoucher";
import VoucherDetailModal from "~/components/vouchers/VoucherDetailModal.vue";
import HeaderAccountMobile from "~/components/Header/HeaderAccountMobile.vue";

export default defineComponent({
  name: "MyCoupon",
  components: {
    SfLoader,
    LazyComponent,
    VoucherItem,
    VoucherDetailModal,
    HeaderAccountMobile,
  },
  setup() {
    const { load } = useWishlist();
    const route = useRoute();
    const { getProductPath } = useProduct();

    const voucherStore = useVoucherStore();
    const voucherData = computed(() => voucherStore.getVoucherData);
    const loading = computed(() => voucherStore.isLoading);
    const itemDetail = ref(<Voucher>null);
    const isModalVoucher = ref(false);
    const change = (data: Voucher) => {
      itemDetail.value = data;
      isModalVoucher.value = true;
    };
    

    onMounted(() => {
      if (voucherData.value?.code !== 200) {
        voucherStore.fetchVoucherDataStore();
      }
    });

    const allVoucherData = computed(
      () => voucherData.value?.result?.vouchers || []
    );
    const voucherOnlineData = computed(
      () =>
        voucherData.value?.result?.vouchers?.filter(
          (e) =>
            e?.voucher_type_apply === "voucher_online" ||
            e?.voucher_type_apply === "voucher_all"
        ) || []
    );
    const voucherOfflineData = computed(
      () =>
        voucherData.value?.result?.vouchers?.filter(
          (e) =>
            e?.voucher_type_apply === "voucher_offline" ||
            e?.voucher_type_apply === "voucher_all"
        ) || []
    );
    const voucherCollectData = (vouchers) =>
      vouchers?.filter((e) => e?.voucher_collect) || [];

    // Add a function to get the appropriate voucher count based on tab index
    const getVoucherCount = (index) => {
      switch (index) {
        case 0:
          return allVoucherData?.value.length;
        case 1:
          return voucherOnlineData?.value.length;
        case 2:
          return voucherOfflineData?.value.length;
        default:
          return 0;
      }
    };

    const {
      query: { page, itemsPerPage },
    } = route.value;
    const th = useUiHelpers();

    const { getMagentoImage, imageSizes } = useImage();

    onMounted(async () => {
      await load({
        searchParams: {
          currentPage: page ? Number.parseInt(page.toString(), 10) : 1,
          pageSize: itemsPerPage
            ? Number.parseInt(itemsPerPage.toString(), 10)
            : 10,
        },
      });
    });

    return {
      loading,
      productGetters,
      th,
      getMagentoImage,
      imageSizes,
      getProductPath,
      voucherData,
      allVoucherData,
      voucherOnlineData,
      voucherOfflineData,
      voucherCollectData,
      getVoucherCount,
      change,
      itemDetail,
      isModalVoucher
    };
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        { title: "Tất cả", content: "" },
        { title: "Online", content: "" },
        { title: "Cửa hàng", content: "" },
      ],
    };
  },
});
